import React from 'react';
import AuditLogList from '../Logs/AuditLogList';
import { getActivityLogs } from '../../services/logactivityService';

const LogActivityList: React.FC = () => <AuditLogList kind="activity" loadLogs={getActivityLogs} />;

export default LogActivityList;

